import { Configuration, PublicClientApplication, RedirectRequest } from '@azure/msal-browser'

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CLIENT_ID ?? '',
        authority: import.meta.env.VITE_MSAL_AUTHORITY,
        redirectUri: '/', // this URI must be registered on Azure Portal/App Registration
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
    scopes: ['User.Read'],
}

export const msalInstance = new PublicClientApplication(msalConfig)
